import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { StatsSection } from 'widgets/statspro/js/components/common/stats-section';
import {
    RoundListNavItem,
    LocationNavItem,
    RegionNavItem
} from 'common/react/components/competition-nav/nav-items';
import { BroadcastGuideCards } from './BroadcastGuideCards';

import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { useCompetitionNavigationOptions } from 'common/react/hooks/use-competition-navigation-options';
import { useNavSync } from 'common/react/components/competition-nav/hooks/use-nav-sync';
import { useGetRegionsQuery } from 'common/store/modules/api/content-api';

export const BroadcastGuide = ({ competitionId, seasonId }) => {
    const initialValues = { competitionId, seasonId };
    const selectedTimeZone = useSelector((state) => state.selectedRegion);
    initialValues.location = selectedTimeZone;

    const nav = useSelector(navSelector);
    const options = useCompetitionNavigationOptions(nav);
    useNavSync({ ...options, initialValues });

    const { data = [] } = useGetRegionsQuery();

    const locations = useMemo(() => {
        if (data.length) {
            return data.reduce((regions, region) => {
                const value = PULSE.app.common.modifyCountryDisplay(
                    region.timezone.split('/')[0]
                );

                const returnValue = {
                    name: value,
                    value,
                    extra: region
                };

                if (!regions.find((obj) => obj.name === returnValue.name)) {
                    regions.push(returnValue);
                }

                return regions.sort((textA, textB) =>
                    textA.name < textB.name
                        ? -1
                        : textA.name > textB.name
                        ? 1
                        : 0
                );
            }, []);
        }
    }, [data]);

    return (
        <>
            <div className="competition-nav">
                <StatsSection.Main>
                    <StatsSection.Nav>
                        <StatsSection.NavItems>
                            <LocationNavItem
                                locations={locations}
                                classes={'competition-nav__location-wrapper'}
                            />
                            <RegionNavItem
                                regions={data}
                                classes={'competition-nav__region-wrapper'}
                            />
                        </StatsSection.NavItems>

                        <StatsSection.RoundButtons>
                            <RoundListNavItem
                                classes={
                                    'competition-nav__round-filter-wrapper'
                                }
                            />
                        </StatsSection.RoundButtons>
                    </StatsSection.Nav>
                </StatsSection.Main>
            </div>
            <div className="wrapper widget">
                <BroadcastGuideCards
                    competitionId={competitionId}
                    seasonId={seasonId}
                />
            </div>
        </>
    );
};

BroadcastGuide.propTypes = {
    competitionId: PropTypes.string.isRequired,
    seasonId: PropTypes.string.isRequired
};
